export default [
  {
    path: '/news/act',
    name: 'act',
    component: () => import(/* webpackChunkName: "news" */ '../../views/news/News.vue'),
    meta: {
      title: '活动详情',
    },
  },
  {
    path: '/news/information',
    name: 'information',
    component: () => import(/* webpackChunkName: "news" */ '../../views/news/News.vue'),
    meta: {
      title: '资讯详情',
    },
  },
]
